import { observer } from "mobx-react";
import { useEffect } from "react";
import toast from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { useGlobalStore } from "../../api/globalStores";
import EngagementPanel from "../Components/EngagementPanelEditor/EngagementPanel";
import EngagementPanelEditor from "../Components/EngagementPanelEditor/EngagementPanelEditor";
import SlideDrawer from "../Components/SlideDrawer";

export interface IEPMakerPage {}

function EPMakerPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const globalStores = useGlobalStore();

  useEffect(() => {
    toast.promise(
      (async () => {
        const moduleId = searchParams.get("module");
        const epanelId = searchParams.get("epanel");

        if (
          moduleId !== null &&
          moduleId !== "undefined" &&
          globalStores.curModule.module.id !== +moduleId
        ) {
          await globalStores.curModule.init(+moduleId);
        }

        if (
          epanelId !== null &&
          epanelId !== "undefined" &&
          globalStores.curEPanel.engagementPanel.id !== +epanelId
        ) {
          await globalStores.curEPanel.init(+epanelId);
        }

        if (
          epanelId !== null &&
          epanelId !== "undefined" &&
          globalStores.curEPanel.engagementPanel.id !== +epanelId &&
          globalStores.curModule.engagementPanels?.[0].id
        ) {
          setSearchParams({
            ...Object.fromEntries(Array.from(searchParams.entries())),
            epanel: String(globalStores.curModule.engagementPanels[0].id),
          });
        }
      })(),
      {
        loading: "Loading Module and Engagement Panel",
        success: "Loaded",
        error: (e: any) => e.message,
      }
    );
  }, [
    searchParams,
    globalStores.curModule,
    globalStores.curEPanel,
    setSearchParams,
  ]);

  const epanelReady =
    !Number.isNaN(globalStores.curEPanel.engagementPanel.id) &&
    globalStores.curEPanel.engagementPanel.id;

  return (
    <div className="h-full w-full flex justify-between bg-brij-Default">
      <SlideDrawer />
      {epanelReady && (
        <>
          <div className="p-6 h-full">
            <EngagementPanel mode="SETUP" />
            {/* <NavigationInstructions /> */}
          </div>
          <EngagementPanelEditor />
        </>
      )}
      {!epanelReady && (
        <div className="w-full h-full grid place-items-center p-4">
          Please create/select an Engagement Panel using the plus icon on the
          left first.
        </div>
      )}
    </div>
  );
}

export default observer(EPMakerPage);
